export enum FundClosedReason {
  FundClosed,
  MissingMarketingPermission,
  UnsupportedCurrency,
  UnsupportedFund,
}
